<template>
  <section class="vue-lightbox search-item__bottom" >
    <section v-if="show_all">
      <ul class="clean-list search-apartments" >
        <apartment v-for="apartment in apartments_arr"
                   :apartment="apartment"
                   :key="apartment.id"
                   @open-gallery="openGallery"
                   v-if="apartments_arr.length > 0"
                   @showModal="modalShow"
        >
        </apartment>
      </ul>
      <button class="btn search-apartments__btn" v-if="apartments.length > 4" @click.prevent="toggleList">
        {{btn_title}} <span v-if="!show_list">{{countMore}}</span>
      </button>
    </section>
    <modal :type="apartment_type" :id="apartment_id" v-if="ShowModal" @close="closeModal"></modal>
    <light-box ref="lightbox"
               :media="gallery"
               :show-caption="false"
               :show-light-box="false">

    </light-box>
  </section>
</template>
<script>
import apartment from './item'
import modal from "./modal";
import LightBox from 'vue-image-lightbox'
import { bus } from './bus.js'
export default {
  components: {
    'apartment':apartment,
    modal,
    LightBox,
  },
  props:["apartments", "id"],
  data() {
    return {
      apartment_id:null,
      apartment_type: "",
      gallery:[
        {
          thumb: '',
          src: '',
        }
      ],
      apartments_arr:[],
      words:['квартиру', 'квартиры', 'квартир'],
      show_list:false,
      btn_title:'Показать еще',
      show_all:true,
      ShowModal:false,
    }
  },
  computed:{
    countMore:function () {
      if(this.apartments.length > 4) {
        let count = this.apartments.length - 4;
        let text = this.num_word(count, this.words);
        return count + ' ' + text;
      }
    }
  },
  methods: {
    modalShow(data) {
      this.apartment_id = data.id;
      this.apartment_type = data.type;
      this.ShowModal =true;
      let vm =this;
      this.$nextTick(function () {
        $(function () {
          $('#apartmentModal').modal('show')
        })

      })
    },
    closeModal() {
      $('#apartmentModal').modal('hide');
      let vm =this;
      $('#apartmentModal').on('hidden.bs.modal', function (e) {
        vm.showModal = false;
      })
    },
    listEventHandler(data) {

      if(data.id == this.id) {
        console.log(data);
        this.show_all = data.status
      }
    },
    toggleList() {
      if(!this.show_list) {
        this.apartments_arr = this.apartments;
        this.show_list = true;
        this.btn_title = 'Свернуть';
      } else {
        this.apartments_arr = this.apartments.slice(0,4);;
        this.show_list = false;
        this.btn_title = 'Показать еще';
      }

    },
    openGallery(media) {

      this.gallery = media;
      this.$refs.lightbox.showImage(0);
    },
    num_word(value, words){
      value = Math.abs(value) % 100;
      var num = value % 10;
      if(value > 10 && value < 20) return words[2];
      if(num > 1 && num < 5) return words[1];
      if(num == 1) return words[0];
      return words[2];
    },
  },
  mounted() {
    bus.$on('list-toggle', this.listEventHandler)
    this.apartments_arr = this.apartments.slice(0,4);
  }

}
</script>